import $ from 'jquery';
import {showFormResponse} from '../common/json-response';
import {setNotChangedForm} from "./save-work-between-step";
import {setSaveButtonActive, setSaveButtonDisabled} from './work-save-button-toggle'

let saveBtn;

function getWorkCommentField() {
  const workComment = document.querySelector('#work_comment');

  const data = {};
  data['comment'] = workComment.value ? workComment.value : '';

  return data;
}

function initWorkCommentStep() {
    saveBtn = document.querySelector('#saveBtn[name="work-comment-save"]');
    const statusWrapper = document.querySelector('.action-status-messages');

    saveBtn?.addEventListener('click', function (e) {
      e.preventDefault();
      setSaveButtonDisabled(saveBtn);

      const data = getWorkCommentField();
      const url = saveBtn.getAttribute('data-url');

      $.ajax({
        type: 'POST',
        data: data,
        url:  url,
        success: function (data) {
          // убираем отметку об изменениях в форме
          // чтобы не было двойного сохранения при закрытии страницы после редиректа
          if (data.status === 'success') {
            setNotChangedForm();
          }

        if (data.redirectTo?.length) {
          if (typeof window.__showWbStepLoader === 'function') {
            window.__showWbStepLoader();
          }
          window.location.href = data.redirectTo;
          return;
        }

          showFormResponse(data);
          setSaveButtonActive(saveBtn);
        },
        error: function (data) {
          showFormResponse(data);
          setSaveButtonActive(saveBtn);
        },
      });
    });
}

export { getWorkCommentField, initWorkCommentStep }